import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useStyle } from '@composables/use-style';
import { useStyleExtension } from '@v1/composables/text';
import BaseText from '@v1/components/base/BaseText.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TextPrimary',
  props: {
  size: {
    type: String,
    required: false,
    default: 'MD',
  },
  weight: {
    type: String,
    required: false,
    default: 'MD',
  },
},
  setup(__props) {

const { colors, fontStyle } = useStyle();

const props = __props;

const styleExtension = useStyleExtension({
  container: {
    color: colors.PRIMARY3(),
    fontSize: fontStyle.SIZE[props.size],
    fontWeight: fontStyle.WEIGHT[props.weight],
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseText, _mergeProps(_ctx.$attrs, { styleExtension: _unref(styleExtension) }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["styleExtension"]))
}
}

})